import { useDesignMaxTheme } from "@/packages";
import { useGetRoom, type RoomPhotoInfoResponse } from "@/shared/server";
import { Box, Center, Spinner, Text } from "@chakra-ui/react";
import { useInView } from "react-intersection-observer";
import { RoomSlides } from "./components";

export const RoomFeed = ({ roomIdx }: { roomIdx: string }) => {
    const { data } = useGetRoom<RoomPhotoInfoResponse>({ section: "photos", roomIdx });
    const { ref, inView } = useInView({ threshold: 0.9, delay: 0.3, triggerOnce: true });
    const { isMobile } = useDesignMaxTheme().MEDIAS();

    return data ? (
        <Box
            ref={ref}
            position="relative"
            w="100%"
            h="100dvh"
            background="#333"
            paddingTop={isMobile ? "64px" : "0"}
            paddingBottom={isMobile ? "24px" : "0"}
        >
            <RoomSlides imgList={data.imgList} inView={inView} />
        </Box>
    ) : (
        <Center w="100" h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};
